import { render } from "./generate.vue?vue&type=template&id=5bd70837&scoped=true"
import script from "./generate.vue?vue&type=script&lang=js"
export * from "./generate.vue?vue&type=script&lang=js"

import "./generate.vue?vue&type=style&index=0&id=5bd70837&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd70837"]])

export default __exports__